import { FC } from "react";
import { DialogData } from "../../types";
import { Icon } from "../../parts/Icon";
import { _ } from "../../utils/helpers";

interface SelectShiftFirstDialogProps {
    dialogData: DialogData
}

export const SelectShiftFirstDialog: FC<SelectShiftFirstDialogProps> = ({dialogData}) => {

    if (dialogData.dialog !== 'select-shift-first') return null
    return (
        <section className="h-100 w-100">
            <div className="pointer-container df aic p-a">
                <p className="instruction-text mr-4 mt-3">{_('2di_selec_q')}</p>
                <Icon icon="pointer"/>
            </div>
        </section>
    )
}